import { requester } from "../utils";

export const getFavorites = (query) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/favorite/me?${query}`,
        method: "GET",
        withAuth: true,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get cafes error", err);
        reject(err);
      });
  });
};

export const newFavorites = (data) => {
  return new Promise((resolve, reject) => {
    requester
      .fetchAPI({
        route: `v1/favorite/toggle`,
        method: "POST",
        withAuth: true,
        data,
      })
      .then((result) => {
        resolve(result.payload);
      })
      .catch((err) => {
        console.log("get cafes error", err);
        reject(err);
      });
  });
};